import React from 'react';
import { useDomainConfig } from '../hooks/useDomainConfig';

interface DomainLogoProps {
  type: 'header' | 'content';
  className?: string;
  style?: React.CSSProperties;
  alt?: string;
  fallbackSrc?: string;
}

const DomainLogo: React.FC<DomainLogoProps> = ({ 
  type, 
  className = '', 
  style,
  alt = 'Logo',
  fallbackSrc = '/logos/default-logo.svg'
}) => {
  const { config, loading } = useDomainConfig();

  console.log('DomainLogo render:', { type, config, loading });

  if (loading) {
    return <div className={`logo-placeholder ${className}`}>Loading...</div>;
  }

  const logoSrc = config?.logo?.[type] || fallbackSrc;
  console.log('DomainLogo logoSrc:', logoSrc);

  return (
    <img 
      src={logoSrc} 
      alt={alt}
      className={className}
      style={style}
      onError={(e) => {
        const target = e.target as HTMLImageElement;
        if (target.src !== fallbackSrc) {
          target.src = fallbackSrc;
        }
      }}
    />
  );
};

export default DomainLogo;